import src from "IMAGE";
export default { src, width: 400, height: 87, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AIUJGphyBxaBiAkbmm8HFn1zCBeBbwcWfnUIF4WACBmSAH4IGY95CBiJgAgZkWYHFHFUBhFfbwcWfnQIF4SACBmSTfoRm/lH4HgAAAAASUVORK5CYII="};
